import script from "./noticeBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./noticeBar.vue?vue&type=script&setup=true&lang=ts"

import "./noticeBar.vue?vue&type=style&index=0&id=74e0b285&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74e0b285"]])

export default __exports__